import { Instagram, ArrowUpRight } from "lucide-react";
import { LINKS, INSTAGRAM_TILES, COPY } from "@/lib/site";
import { Reveal } from "./Motion";
import { Img } from "./Img";

export const InstagramStrip = () => {
  return (
    <section data-testid="instagram-section" className="grain py-24 md:py-32 bg-surface">
      <div className="container-editorial">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <p className="kicker mb-5">{COPY.instagram.kicker}</p>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
              {LINKS.instagramHandle}
            </h2>
          </div>
          <a
            data-testid="instagram-follow"
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost self-start md:self-auto"
          >
            <Instagram size={16} /> {COPY.instagram.followLabel}
          </a>
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {INSTAGRAM_TILES.map((t, i) => (
            <Reveal key={t.img} delay={(i % 6) * 0.05}>
              <a
                data-testid={`instagram-tile-${i + 1}`}
                href={LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block overflow-hidden rounded-sm aspect-square"
                aria-label="View on Instagram"
              >
                <Img
                  name={t.img}
                  alt={t.alt}
                  imgClassName="w-full h-full transition-transform [transition-duration:1200ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/40 transition-colors duration-500 flex items-center justify-center">
                  <Instagram
                    size={26}
                    className="text-beige opacity-0 scale-90 group-hover:opacity-100 group-hover:scale-100 transition-all duration-500"
                  />
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-8">
          <a
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-ink hover:gap-3 transition-all duration-300"
          >
            {COPY.instagram.moreLabel}
            <ArrowUpRight size={16} />
          </a>
        </Reveal>
      </div>
    </section>
  );
};
